import {
    GET_JOB,
    GET_JOB_CANDIDATES,
    SET_JOB_VIEW_LOADER,
    CLEAR_JOB_CANDIDATES,
} from 'store/actions/actionTypes'
import { ITEMS_PER_PAGE } from 'Data/constants'
import { updateObject } from 'store/reducers/utility'

const initialState = {
    total: 0,
    job: {},
    candidates: [],
    loader: false,
    size: ITEMS_PER_PAGE,
    filters: {},
    sorter: 'candidateId',
    activeSorter: {},
    activeFilters: [],
}

export default (state = initialState, action) => {
    switch (action.type) {

        case GET_JOB:
        case GET_JOB_CANDIDATES:
        case SET_JOB_VIEW_LOADER:
        case CLEAR_JOB_CANDIDATES:
            return updateObject(state, { ...action })

        default:
            return state
    }
}
